module.exports = __webpack_public_path__ + "static/img/r-3-2-icon.f6dab14.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer3/en/role-3/r-3-2-icon.png
// module id = 3+Bh
// module chunks = 0